import { render, staticRenderFns } from "./RenderService.vue?vue&type=template&id=24ddea20"
import script from "./RenderService.vue?vue&type=script&lang=js"
export * from "./RenderService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports